
const formato = (num) =>{
    const numberToConvert = ((num/100).toFixed(2)).toString().split('.')
    let splitter = numberToConvert[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if(numberToConvert[1]){
        splitter += "." + numberToConvert[1].substr(0,3);
    }
    return splitter;
}

const allInputNumbers = document.querySelectorAll('.input-number-cart');

allInputNumbers.forEach((input)=>{
    input.addEventListener('change', (e)=>{
        const name = e.target.parentNode.id;
        console.log(name)
        let value = e.target.value;
        const resultTotal = document.getElementById('subtotal-cart');
        const resultPerItem = document.getElementById(`peritem_${name}`);
        
        if((value/1) === 0){
            // alert('Esta cantidad no puede ser igual a 0');
            input.value = 1
            // return;
        }
        
        if((value/1) > (input.max/1)){
            // alert(`Esta cantidad no puede ser mayor a ${input.max}`);
            input.value = input.max

            $('.js-cart-stock').each( function (){
                if ( name == $(this).data('cart-stock__id') ) {
                    $(this).addClass($(this).data('cart-stock__active'))
                    setTimeout(() => {
                        $(this).removeClass($(this).data('cart-stock__active'))
                    }, 3000)
                }
            })
            // return;
        }

        value = input.value

        $.ajax({
            url: "/cart/change",
            type: "post",
            data: {
                id: name,
                quantity: value
            },
            dataType: 'json',
            async: false,
            success: res => {
                //console.log(res);
                const itemActual = res.items.filter(item => (item.id).toString() === name);
                resultTotal.innerHTML = '$' + formato(res.total_price);
                resultPerItem.innerHTML = '$' + formato(itemActual[0].final_line_price);
                localStorage.setItem('atom_cart', JSON.stringify(res))
            },
            error: err => {
                console.log('ERROR', err);
                alert('Algo salio mal');
            }
        })

       

       
    })
})


const updateItem = (e) =>{
    //console.log('desde js aparte', e.target)
    
    const name = e.target.parentNode.id
    //console.log(event.target.parentNode.id);
    const input = document.querySelector(`#updates_${name}`);
    const resultTotal = document.getElementById('subtotal-cart');
    const resultPerItem = document.getElementById(`peritem_${name}`);
    let valueItems = input.value


    if(e.target.id === 'mas'){
        valueItems = parseInt(valueItems) + 1
        input.value = valueItems
        
        if ( (input.value/1) > (input.max/1) ) {
            input.value = (input.max/1)
        }

    }
    if(e.target.id === 'menos'){
        if(parseInt(input.value) > 1 ){
            valueItems = parseInt(valueItems) - 1
            input.value = valueItems
        }else{
            input.value = 1
            return;
        }
    }
    $.ajax({
        url: "/cart/change",
        type: "post",
        data: {
            id: name,
            quantity: valueItems
        },
        dataType: 'json',
        async: false,
        success: res => {
            //console.log(res);
            const itemActual = res.items.filter(item => (item.id).toString() === name);
            resultTotal.innerHTML = '$' + formato(res.total_price);
            resultPerItem.innerHTML = '$' + formato(itemActual[0].final_line_price);
            localStorage.setItem('atom_cart', JSON.stringify(res))
        },
        error: err => {
            console.log('ERROR', err);
            alert('Algo salio mal');
        }
    })



}




// Funcion para el mensaje de venta por metro cuadrado


const popMensaje = () =>{
    //280
    //-290
    const popBtn = document.querySelectorAll('.js-pop-m');

    popBtn.forEach((btn)=>{
        const msg = btn.querySelector('span');
        btn.addEventListener('click', ()=>{
            //console.log(msg);
            if(msg.getBoundingClientRect().width > 0){
                msg.style.width = '0px';
                msg.style.left = '-20px';
                msg.style.transition = 'all 0.3s';
            }else{
                msg.style.width = '280px';
                msg.style.left = '-290px';
                msg.style.transition = 'all 0.3s';
            }
        })
    });

    
    
    //console.log(popBtn);
}

popMensaje();